var _rect, _rect2, _circle, _g, _path, _path2, _g2, _path3, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgAdcs = function SvgAdcs(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 46,
    height: 35,
    rx: 2,
    fill: "#FFB627"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 44,
    r: 12,
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1730_48696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1852 41.1297H44.4929C44.5881 41.1297 44.6516 41.1487 44.7277 41.2249L45.6481 42.1453C46.5495 43.053 47.4382 43.053 48.3395 42.1453L49.2663 41.2249C49.3425 41.1487 49.3996 41.1297 49.4948 41.1297H50.8088C52.0783 41.1297 52.7067 40.4949 52.7067 39.2254V37.9178C52.7067 37.8226 52.7385 37.7527 52.8019 37.6893L53.7287 36.7625C54.6301 35.8611 54.6301 34.9725 53.7287 34.0711L52.8019 33.1444C52.7321 33.0745 52.7067 33.011 52.7067 32.9158V31.6082C52.7067 30.3323 52.0783 29.7039 50.8088 29.7039H49.4948C49.3996 29.7039 49.3361 29.6722 49.2663 29.6087L48.3395 28.6819C47.4318 27.7742 46.5495 27.7742 45.6481 28.6883L44.7277 29.6087C44.6579 29.6722 44.5881 29.7039 44.4929 29.7039H43.1852C41.9094 29.7039 41.2809 30.3196 41.2809 31.6082V32.9158C41.2809 33.011 41.2556 33.0745 41.1857 33.1444L40.2653 34.0711C39.3576 34.9725 39.364 35.8611 40.2653 36.7625L41.1857 37.6893C41.2556 37.7527 41.2809 37.8226 41.2809 37.9178V39.2254C41.2809 40.5013 41.9157 41.1297 43.1852 41.1297Z",
    fill: "#1A1D25",
    fillOpacity: 0.15
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5151 38.2354C45.731 38.4956 45.9849 38.6479 46.3022 38.6479C46.6069 38.6479 46.8862 38.4829 47.0703 38.2163L49.9966 33.8174C50.1235 33.6396 50.1807 33.4492 50.1807 33.2778C50.1807 32.8335 49.7871 32.5098 49.3491 32.5098C49.0635 32.5098 48.835 32.6685 48.6382 32.9731L46.2896 36.6802L45.2803 35.4805C45.1025 35.271 44.9121 35.1694 44.6582 35.1694C44.2139 35.1694 43.8457 35.5186 43.8457 35.9692C43.8457 36.1787 43.9092 36.3438 44.0806 36.5469L45.5151 38.2354Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4668 23.1797C19.9004 23.1797 19.4707 22.75 19.4707 22.1836C19.4707 21.6172 19.9199 21.168 20.4668 21.168H50.0605C50.627 21.168 51.0762 21.6172 51.0762 22.1836C51.0762 22.75 50.627 23.1797 50.0605 23.1797H20.4668ZM20.4668 29.4492C19.9199 29.4492 19.4707 29 19.4707 28.4336C19.4707 27.8867 19.9199 27.4375 20.4668 27.4375H34.8848C35.4512 27.4375 35.8809 27.8867 35.8809 28.4336C35.8809 29 35.4512 29.4492 34.8848 29.4492H20.4668ZM21.1398 33.6875H32.0605C32.627 33.6875 33.0762 34.1172 33.0762 34.6836C33.0762 35.25 32.627 35.6992 32.0605 35.6992H23.6659C22.9202 34.921 22.0708 34.243 21.1398 33.6875ZM26.8574 42.1445C26.75 41.4526 26.5835 40.7803 26.3632 40.1328H34.8848C35.4512 40.1328 35.8809 40.5625 35.8809 41.1289C35.8809 41.6953 35.4512 42.1445 34.8848 42.1445H26.8574Z",
    fill: "url(#paint0_radial_1730_48696)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1730_48696)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 44,
    r: 12,
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12012 43.996C7.12012 44.2257 7.20721 44.4553 7.38932 44.6215L11.5698 48.7387C11.7361 48.905 11.9736 49 12.1795 49C12.6783 49 13.0029 48.6516 13.0029 48.1766C13.0029 47.9311 12.9158 47.749 12.7575 47.5986L11.0394 45.9279L9.68544 44.7641L11.4669 44.8353H18.5374L20.3189 44.7641L18.957 45.9279L17.2389 47.5986C17.0884 47.749 16.9934 47.9311 16.9934 48.1766C16.9934 48.6516 17.326 49 17.8248 49C18.0306 49 18.2682 48.905 18.4265 48.7387L22.615 44.6215C22.7892 44.4553 22.8842 44.2257 22.8842 43.996C22.8842 43.7664 22.7892 43.5447 22.615 43.3705L18.4265 39.2613C18.2682 39.095 18.0306 39 17.8248 39C17.326 39 16.9934 39.3484 16.9934 39.8234C16.9934 40.0689 17.0884 40.251 17.2389 40.4014L18.957 42.0721L20.3189 43.2359L18.5374 43.1568H11.4669L9.68544 43.2359L11.0394 42.0721L12.7575 40.4014C12.9158 40.251 13.0029 40.0689 13.0029 39.8234C13.0029 39.3484 12.6783 39 12.1795 39C11.9736 39 11.7361 39.095 11.5698 39.2613L7.38932 43.3705C7.20721 43.5447 7.12012 43.7664 7.12012 43.996Z",
    fill: "#FFB627"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1730_48696",
    x: 39.5869,
    y: 28.002,
    width: 14.8174,
    height: 15.701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.876799
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.438399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1730_48696"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1730_48696",
    x: 1,
    y: 31,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1730_48696"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1730_48696",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1730_48696",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51 21) rotate(-180) scale(32 48.2145)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.25
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdcs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adcs.e377f88ff30de6d64fe277587244d634.svg";
export { ForwardRef as ReactComponent };